import axios from 'axios';

export const getVisitorsReport = async ({ queryKey }) => {
  console.log('queryKey', queryKey);
  const { data } = await axios.post('/FrmAnswer/FormsAnswerReport', queryKey[1]);
  return data;
};
